/**
 * Iconos disponibles para módulos.
 * Agrupados por categoría para que sea fácil mantener / extender.
 */
export const AVAILABLE_ICONS: string[] = [
  // Generales
  'home', 'dashboard', 'layers', 'category', 'widgets', 'apps',
  // Los del menú actual del proyecto (sidebar) que faltaban aquí
  'calendar_month', 'menu_book', 'assessment', 'fact_check', 'support_agent', 'group',
  // Los que usa el seed de módulos (seed_modulos_permisos.sql) y faltaban:
  // sin ellos, al editar un módulo sembrado el selector no encuentra su icono.
  'account_tree', 'apartment', 'cable', 'devices_other', 'local_shipping',
  'medical_information', 'school', 'sell', 'settings_suggest', 'square_foot', 'straighten',
  // Operación / Salud
  'monitor_heart', 'medical_services', 'biotech', 'vaccines',
  'health_and_safety', 'medication', 'science', 'local_hospital',
  // Inventario
  'inventory_2', 'warehouse', 'shopping_cart', 'folder_open',
  // Documentos / Reportes
  'assignment', 'description', 'article', 'summarize', 'analytics',
  'insights', 'bar_chart', 'receipt_long',
  // Personas / Roles
  'people', 'person', 'badge', 'admin_panel_settings', 'manage_accounts',
  // Seguridad
  'security', 'lock', 'shield', 'verified_user', 'key',
  // Comunicación / Notificaciones
  'mail', 'email', 'notifications', 'campaign',
  // Acciones / Herramientas
  'settings', 'build', 'engineering', 'construction', 'handyman', 'tune',
  // Calendario / Tiempo
  'calendar_today', 'event', 'schedule', 'history',
  // Negocio / Finanzas
  'business', 'corporate_fare', 'attach_money', 'request_quote',
  // Mapas / Lugares
  'place', 'location_on', 'map', 'public',
  // Datos / IO
  'cloud_upload', 'cloud_download', 'sync', 'storage', 'hub', 'schema',
  'precision_manufacturing','factory','contact_page','gavel','swap_horiz','event_note','confirmation_number',
  // Módulos de procesos (Adquisición, Satisfacción, Quejas, Devoluciones)
  'payments','sentiment_satisfied','assignment_late','report_problem','assignment_return','ballot','propane_tank',
  'gas_meter',
  // RFID / lectura
  'contactless', 'nfc', 'sensors', 'rss_feed', 'wifi_tethering', 'settings_remote',
  'home_work', 'handshake', 'move_down', 'assignment_ind',
  'qr_code', 'qr_code_2', 'qr_code_scanner', 'barcode_reader', 'cloud', 'cloud_sync',
  // Salida de material: folio / remisión
  'post_add', 'note_add', 'receipt', 'edit_note', 'task_alt', 'assignment_turned_in',
  'pending_actions', 'playlist_add', 'playlist_add_check', 'move_to_inbox', 'inbox', 'shelves',
  // Auditoría / búsqueda / historial
  'inventory', 'manage_search', 'person_search', 'timeline', 'login', 'logout', 'filter_list',
  'list_alt', 'table_rows', 'grid_view', 'data_usage', 'done_all', 'verified',
  // Documentos / archivos
  'picture_as_pdf', 'upload_file', 'attach_file', 'upload', 'download', 'file_download',
  'download_for_offline', 'folder_special', 'image', 'photo_camera', 'draw', 'notes',
  // Personas
  'account_circle', 'person_add', 'person_outline', 'person_off', 'lock_reset', 'workspace_premium',
  'military_tech',
  // Estados / avisos
  'warning', 'error_outline', 'info', 'help_outline', 'check_circle', 'pending', 'event_available',
  'event_busy', 'schedule_send', 'notifications_off', 'thermostat', 'star', 'bookmark', 'label',
  'tag', 'domain', 'language', 'link', 'open_in_new', 'smartphone', 'phone', 'app_registration',
  'play_circle', 'visibility', 'save', 'search', 'edit', 'delete', 'add_box', 'cancel',
];
